import { Component, OnInit, Input, EventEmitter, Output, ViewChild, QueryList } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalIframeService } from './modal-iframe.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'modal-iframe',
    templateUrl: 'modal-iframe.html'
})


export class ModalIframeComponent implements OnInit {
    public showModal;
    public url = null;
    public sanitizer;
    @ViewChild('iframeModal') public iframeModal:ModalDirective;
    constructor(private modalIframeService: ModalIframeService, private domSanitizer: DomSanitizer) { 
        this.sanitizer = domSanitizer;
    }

    public onHidden():void{
       this.iframeModal.hide()
    }

    public closeModal():void{
       this.iframeModal.hide()
    }

    ngOnChanges(value) {
    
        (this.showModal) ? this.iframeModal.show() : this.iframeModal.hide();
    }
    ngOnInit() { 
        this.modalIframeService.getModalListener().subscribe(message => { 
            //console.log(message);
            //this.url = this.sanitizer.bypassSecurityTrustResourceUrl(message);
            this.iframeModal.show()
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/common/iframe/modal-iframe.component.ts